import { initAjaxHandlers } from './parser/utils';

export default class ScriptManager {
  // Tracks whether jQuery.ready has been blocked
  #jqueryReadyBlocked = false;

  constructor(theme) {
    this.theme = theme;
  }

  /**
   * Called when a script is loaded.
   */
  onScriptLoad() {
    this.#blockJqueryReady();
    initAjaxHandlers(this.theme);
  }

  /**
   * Called when all assets (scripts, styles, etc.) are loaded.
   */
  onAllAssetsLoaded() {
    this.#unblockJqueryReady();
  }

  // Block jQuery ready callbacks once
  // Why: Some scripts depend on other scripts being loaded first,
  // so we prevent $(document).ready callbacks from running prematurely.
  #blockJqueryReady() {
    if (!this.#jqueryReadyBlocked && window.jQuery) {
      window.jQuery.readyWait++;
      this.#jqueryReadyBlocked = true;
    }
  }

  // Unblock jQuery ready callbacks
  #unblockJqueryReady() {
    if (this.#jqueryReadyBlocked && window.jQuery) {
      window.jQuery.ready(true);
    }
  }
}
